import {
  Option,
  DepositPayable,
  DayType,
  Condition,
} from '@urbanx/agx-ui-components';
import { SegmentItem } from '@urbanx/agx.ui-components2';

export const getPayableSegments = (isInverted?: boolean): SegmentItem[] => {
  const segments = [
    {
      title: '# days from...',
      xsTitle: '# days from...',
      value: DepositPayable.NDaysFrom,
    },
    {
      title: 'on...',
      xsTitle: 'on...',
      value: DepositPayable.On,
    },
  ];

  if (isInverted) {
    return segments.reverse();
  }

  return segments;
};

export const DAYS_BUSINESSDAYS_OPTIONS: Option[] = [
  { label: 'day(s)', value: DayType.Days },
  { label: 'business day(s)', value: DayType.BusinessDays },
];

export const DAYS_FROM_OPTIONS: Option[] = [
  {
    value: Condition.FinanceBeingSatisfied,
    label: 'finance being satisfied',
  },
  {
    value: Condition.BuildingAndPestBeingSatisfied,
    label: 'building and pest being satisfied',
  },
  {
    value: Condition.UponSatisfactionOfSpecialCondition,
    label: 'satisfaction of special condition',
  },
];

export const DefaultErrorState = { depositError: false, message: '' };
